export default __webpack_public_path__ + "GreycliffCF-Medium.woff2";